import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useEffectOnce } from 'react-use';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useAccountOwnerSelect } from './useAccountOwnerSelect';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { FormFields } from '../../AccountForm.meta';
import { AccountModalUsageContext } from '../../context/AccountFormProvider.meta';
import {
  Donor,
  GivingStrategy,
} from '../../../../../../../../CharitableGivingWorkflow/stages/CharitableGiving/api/useCharitableGivingQuery';

export const AccountOwnerSelect = () => {
  const { options } = useAccountOwnerSelect();

  const { options: peopleOptions } = options[0];

  const { setAlert, usageContext, usageContextOptions } = useAccountFormContext();

  const formBag = useFormContext<FormFields>();
  const { control, setValue, watch } = formBag;

  const accountBeneficiaries = watch('bankAccount.AccountBeneficiaries');

  useEffectOnce(() => {
    if (usageContext === AccountModalUsageContext.CharitableGivingWorkflow) {
      if (typeof usageContextOptions?.CharitableGivingDonor === 'number') {
        formBag.setValue(
          'bankAccount.AccountOwner',
          usageContextOptions?.CharitableGivingDonor === Donor.Spouse
            ? peopleOptions[1]
            : peopleOptions[0],
        );
      }
    }
  });

  if (
    usageContextOptions?.CharitableGivingStrategy === GivingStrategy.QualifiedCharitableDonations
  ) {
    return null;
  }

  return (
    <Controller
      control={control}
      name="bankAccount.AccountOwner"
      render={({ field: { value, onChange } }) => {
        return (
          <Select
            isPortal
            value={value}
            options={options}
            onChange={owner => {
              if (peopleOptions.find(option => option.value === owner?.value)) {
                if ((accountBeneficiaries?.Beneficiaries || []).length > 0) {
                  setAlert({
                    message:
                      'Changing account ownership of this account will result in the removal of existing beneficiary designations. Please re-designate beneficiaries for this account.',
                    type: 'info',
                  });
                  setValue('bankAccount.AccountBeneficiaries.Beneficiaries', []);
                }
              } else {
                setAlert({
                  message:
                    "Changing account ownership of this account will result in the trust's beneficiary designations superseding the existing account beneficiaries.",
                  type: 'info',
                });
              }

              onChange(owner);
            }}
            label="Account Owner"
          />
        );
      }}
    />
  );
};
